// Zahlart eines Verkaufs (Kundenwunsch 14.10.2026): Die Schnittstelle liefert nur payment_method ('sumup' = Karte,
// sonst Bar; abgeleitet aus der Terminal-Transaktion). Die Drucker-App schreibt seit dem Redesign zusätzlich
// custom_data.paymentMethod: 'voucher' = Gutschein (Code in voucherCode, Format in voucherCodeFormat) und
// 'card_external' = Karte am externen Terminal (Transaktion „EXTERN-…“, payment_method ist dann schon 'sumup').
// Reihenfolge: Gutschein vor Karte vor Bar. Liste, Filter, Gruppierung, Detail und Excel nutzen nur diese Datei.
// Saldo, Fahrerabrechnung und Dashboard rechnen im Backend und zählen Gutscheine bis zu dessen Anpassung als Bar.

export const ZAHLARTEN = [
  { value: 'bar', text: 'Bar', export: 'Bar', icon: 'banknote' },
  { value: 'karte', text: 'Karte', export: 'Kartenzahlung', icon: 'card' },
  { value: 'gutschein', text: 'Gutschein', export: 'Gutschein', icon: 'ticket' }
];

// custom_data der Schnittstelle (JSON-Text oder Objekt) sicher lesen; ohne oder bei Fehler {}
export function customData(row) {
  const raw = row && row.custom_data;
  if (!raw) {
    return {};
  }
  if (typeof raw === 'object') {
    return raw;
  }
  try {
    const data = JSON.parse(raw);
    return data && typeof data === 'object' ? data : {};
  } catch (e) {
    return {};
  }
}

// je Zeile einmal berechnet (Filter, Gruppierung und Zelle fragen oft dieselbe Zeile)
const cache = new WeakMap();

// 'bar' | 'karte' | 'gutschein'
export function zahlart(row) {
  if (!row) {
    return 'bar';
  }
  if (cache.has(row)) {
    return cache.get(row);
  }
  let wert = row.payment_method == 'sumup' ? 'karte' : 'bar';
  const raw = row.custom_data;
  // nur parsen, wenn überhaupt eine Zahlart der App drinsteht (die meisten Zeilen haben kein custom_data)
  if (raw && (typeof raw === 'object' || String(raw).indexOf('paymentMethod') !== -1)) {
    const methode = customData(row).paymentMethod;
    if (methode === 'voucher') {
      wert = 'gutschein';
    } else if (methode === 'card_external') {
      wert = 'karte';
    }
  }
  cache.set(row, wert);
  return wert;
}

export function zahlartInfo(row) {
  const wert = zahlart(row);
  return ZAHLARTEN.find((z) => z.value === wert) || ZAHLARTEN[0];
}

export function zahlartText(value) {
  const item = ZAHLARTEN.find((z) => z.value === value);
  return item ? item.text : String(value);
}

// Karte am externen, nicht verbundenen Terminal (Drucker-App)
export function istKarteExtern(row) {
  return customData(row).paymentMethod === 'card_external' ||
    String((row && row.sumup_transaction_code) || '').indexOf('EXTERN-') === 0;
}
